import React, { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const ModalCombinables = ({
  productoBase,
  productos,
  onClose,
  onCombinacionCreada,
  combinacionesExistentes = [],
}) => {
  console.log(productoBase);

  const { token } = useAuth();
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Filtro: mismos bultos, precio_mayorista_a y parte del nombre
  const filtro = productoBase
    ? {
      cantidad_bultos: productoBase.cantidad_bultos,
      precio_mayorista_a: parseInt(productoBase.precios?.precio_mayorista_a, 10),
      nombre: productoBase.nombre_producto
        .split(" ")
        .slice(0, 2)
        .join(" ")
        .toLowerCase(),
    }
    : null;

  // Buscar la combinación actual (solo una por producto)
  const combinacionActual = (productoBase.combinaciones || []).find((comb) => {
    const ids = comb.productos?.map((p) => p.id) || [];
    return ids.includes(productoBase.id);
  });

  useEffect(() => {
    if (combinacionActual) {
      // Selecciona todos los productos de la combinación actual (excepto el base) que estén en productosFiltrados
      const idsFiltrados = productosFiltrados.map((p) => p.id);
      const idsCombinados = combinacionActual.productos
        .filter((p) => p.id !== productoBase.id)
        .map((p) => p.id);

      const idsIniciales = idsCombinados.filter((id) => idsFiltrados.includes(id));
      setSelectedIds(idsIniciales);

      // LOGS PARA DEBUG
      console.log("combinacionActual:", combinacionActual);
      console.log("productosFiltrados:", productosFiltrados);
      console.log("idsFiltrados:", idsFiltrados);
      console.log("idsCombinados:", idsCombinados);
      console.log("idsIniciales (selectedIds):", idsIniciales);
    } else {
      setSelectedIds([]);
    }
    // eslint-disable-next-line
  }, [combinacionActual?.id, productoBase?.id, productos]);

  const idsEnCombinacionActual = combinacionActual
    ? combinacionActual.productos.map(p => p.id)
    : [];

  // productosFiltrados debe estar definido antes del useEffect:
  const productosFiltrados = productos.filter((p) => {
    const nombreBase = filtro.nombre;
    const nombreProd = p.nombre_producto.toLowerCase();
    const precioProd = parseInt(p.precios?.[0]?.precio_mayorista_a, 10);
    return (
      p.id !== productoBase.id &&
      p.cantidad_bultos === filtro.cantidad_bultos &&
      precioProd === filtro.precio_mayorista_a &&
      nombreProd.includes(nombreBase)
    );
  });

  const toggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const handleConfirmar = async () => {
    setError("");
    setLoading(true);
    try {
      const productos_ids = [productoBase.id, ...selectedIds];
      const nombre = combinacionActual
        ? combinacionActual.nombre
        : `Combinación de ${productoBase.nombre_producto}`;

      if (combinacionActual) {
        // Si ya existe, actualiza la combinación (PUT)
        const res = await axios.put(
          `${import.meta.env.VITE_API_URL}/combinaciones/${combinacionActual.id}`,
          { nombre, productos_ids },
          { headers: { "x-auth-token": token } }
        );
        if (onCombinacionCreada) onCombinacionCreada(res.data);
      } else {
        // Si no existe, crea una nueva (POST)
        const res = await axios.post(
          `${import.meta.env.VITE_API_URL}/combinaciones`,
          { nombre, productos_ids },
          { headers: { "x-auth-token": token } }
        );
        if (onCombinacionCreada) onCombinacionCreada(res.data.combinacion);
      }
      onClose();
    } catch (err) {
      setError(err.response?.data?.error || "Error al guardar combinación");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-lg w-full shadow-lg">
        <h2 className="text-xl font-bold mb-4">Seleccionar combinables</h2>
        <div className="mb-4">
          <div className="font-semibold mb-2">Producto base:</div>
          <div className="p-2 bg-gray-100 rounded">{productoBase.nombre_producto}</div>
        </div>
        <div className="mb-4 grid grid-cols-1 gap-2 max-h-60 overflow-y-auto">
          {productosFiltrados.length === 0 && (
            <div className="text-gray-500">No hay productos combinables.</div>
          )}
          {productosFiltrados.map((prod) => {
            const yaIncluido = idsEnCombinacionActual.includes(prod.id);
            const isSelected = selectedIds.includes(prod.id);

            return (
              <label
                key={prod.id}
                className={`flex items-center gap-2 border rounded p-2 cursor-pointer transition ${isSelected
                  ? "bg-green-100 border-green-400"
                  : yaIncluido
                    ? "bg-yellow-100 border-yellow-400"
                    : "hover:bg-gray-100"
                  }`}
              >
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => toggle(prod.id)}
                />
                <span>{prod.nombre_producto}</span>
                {yaIncluido && !isSelected && (
                  <span className="text-xs text-yellow-600 ml-auto">(Ya en combinación)</span>
                )}
              </label>
            );
          })}

        </div>
        {error && <div className="text-red-500 mb-2">{error}</div>}
        <div className="flex justify-end gap-2 mt-4">
          <button
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
            onClick={onClose}
            disabled={loading}
          >
            Cancelar
          </button>
          <button
            className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700"
            onClick={handleConfirmar}
            disabled={loading || selectedIds.length === 0}
          >
            {loading ? "Creando..." : "Confirmar"}
          </button>
        </div>
        {combinacionActual && (
          <div className="mt-4 text-xs text-gray-500">
            Ya existe una combinación con estos productos. Puedes modificarla y se actualizará.
          </div>
        )}
      </div>
    </div>
  );
};

export default ModalCombinables;
